"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const _usa_password_1 = __importDefault(require("@uswds/uswds/js/_usa-password"));
const ShowPassword = (0, react_1.forwardRef)(({ target }, ref) => {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` function to initialize the component
        _usa_password_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            _usa_password_1.default.off(containerEl);
        };
    }, []);
    const multiple = Array.isArray(target);
    const ariaControls = multiple ? target.join(' ') : target;
    return ((0, jsx_runtime_1.jsx)("span", { className: "bah-uswds-show-password", ref: containerRef, children: (0, jsx_runtime_1.jsx)("button", { type: "button", ref: ref, "aria-controls": ariaControls, className: "usa-show-password", "data-show-text": multiple ? 'Show my typing' : 'Show password', "data-hide-text": multiple ? 'Hide my typing' : 'Hide password', children: multiple ? 'Show my typing' : 'Show password' }) }));
});
exports.default = ShowPassword;
